var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUpCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 277.717,
    y1: 41.899,
    x2: 277.717,
    y2: -510.805,
    gradientTransform: "rotate(-90 550.698 58.204) scale(1.1908)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.322,
    style: {
      stopColor: "#6abe30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    style: {
      stopColor: "#70c536"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    style: {
      stopColor: "#ace585"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    style: {
      stopColor: "#ace585"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.4 246.2c-4.6 4.6-4.6 12.1 0 16.8 4.6 4.6 12.1 4.6 16.8 0l89.9-89.9V412c0 6.6 5.3 11.9 11.9 11.9 6.6 0 11.9-5.3 11.9-11.9V173.2l89.9 89.9c2.2 2.2 5.2 3.5 8.4 3.5 3.1 0 6.2-1.3 8.4-3.5s3.5-5.3 3.5-8.5-1.3-6.2-3.5-8.5L264.5 136c-2.2-2.2-5.3-3.5-8.5-3.5s-6.2 1.3-8.5 3.5L137.4 246.2z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 255.997,
    y1: 543.536,
    x2: 255.997,
    y2: -114.627,
    gradientTransform: "rotate(-90 255.997 257.144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.322,
    style: {
      stopColor: "#6abe30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    style: {
      stopColor: "#70c536"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    style: {
      stopColor: "#ace585"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    style: {
      stopColor: "#ace585"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 257.1C0 360.7 62.4 454 158 493.7c95.7 39.6 205.8 17.7 279-55.5 100-100 100-262 0-362s-262-100-362 0C26.8 124-.2 189.2 0 257.1zm488.2 0c0 128-104.2 232.2-232.2 232.2S23.8 385.1 23.8 257.1 128 24.9 256 24.9s232.2 104.2 232.2 232.2z",
    style: {
      fill: "url(#b)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpCircle);
export default __webpack_public_path__ + "static/media/arrow-up-circle.8998db4227b8e0d0c2da6d58b308218b.svg";
export { ForwardRef as ReactComponent };